import React, {Component} from 'react';

import {inject, observer} from 'mobx-react'
import {MODAL_QUESTION_INFO} from "../store/const";

@inject("store")
@observer
export default class InfoFooterApp extends Component {
    constructor(props) {
        super(props);
    }

    showModal = () => {
        this.props.store.showModal(MODAL_QUESTION_INFO)
    };

    render() {
        let {questionCount, hasResult} = this.props.store;

        const shownQuestionCount = hasResult ? '' : questionCount;

        let infoText = 'Mere info til dette spørgsmål';
        
        if (questionCount === 1) infoText = "Mere info om Fristberegneren";
        if (hasResult) infoText = 'Mere info til resultatet';

        return (
            <div className="info-more" onClick={this.showModal}>
                <div className="info-wrap">
                    <span className="txt">
                    {!hasResult &&
                    <span className="index">{shownQuestionCount}</span>
                    }
                        {infoText} - <strong>klik her</strong>
                    </span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/QuestionInfoFooter.js